export const convertOption = (array) => {
  return array.map((item, index) => {
    return {
      value: item.id,
      label: item.name,
    };
  });
};
// HK/CN chưa có vùng (area) riêng trong master → dùng chung dữ liệu vùng phồn thể (TW).
const normalizeAreaCode = (lang) => (lang === 'HK' || lang === 'CN') ? 'TW' : lang;

export const convertOptionArea = (array, lang) => {
  let langSelected = localStorage.getItem("LANG");
  if (!langSelected) {
    langSelected = 'JP'
  }
  const areaCode = normalizeAreaCode(langSelected)
  const arrFilter = array.filter(item => item.code === areaCode)
  return arrFilter.map((item, index) => {
    return {
      value: item.id,
      label: getName(langSelected, item),
    };
  });
};

const getName = (langSelected, item) => {
  if (langSelected === 'KR') {
    return item.name_kr;
  } else if (langSelected === 'TW' || langSelected === 'HK' || langSelected === 'CN') {
    // HK/CN chưa có tên vùng riêng → dùng tên phồn thể (TW)
    return item.name_tw;
  } else if (langSelected === 'EN') {
    return item.name_en;
  } else {
    return item.name;
  }
};


export const convertOptionAreaEdit = (array, areaId, lang) => {
  const arrFilter = array.filter(item => item.id === areaId)
  const codeNa = arrFilter[0]?.code ?? 'JP'
  const areaFilter = array.filter(item => item.code === codeNa)
  return areaFilter.map((item, index) => {
    return {
      value: item.id,
      label: getName(lang, item),
    };
  });
};

export const convertOptionMaster = (array) => {
  return array.map((item, index) => {
    return {
      value: item.code,
      label: item.value,
    };
  });
};
export const convertOptionDiaper = (array) => {
  return array.map((item, index) => {
    return {
      value: item.id,
      label: item.size,
    };
  });
};
export const convertObjectToParams = (obj) => {
  return new URLSearchParams(obj).toString();
};

export const convertPartnerListSelected = (array) => {
  return array.map((item, index) => {
    return {
      value: item.id,
      label: item.name,
    };
  });
};


// Edge case #9: nếu trùng tên Partner/Cơ sở → thêm suffix "(ID:xxx)" để phân biệt.
export const appendDupSuffix = (array) => {
  if (!Array.isArray(array)) return array;
  const counts = {};
  array.forEach((it) => {
    const n = it?.name ?? "";
    counts[n] = (counts[n] || 0) + 1;
  });
  return array.map((it) => {
    const n = it?.name ?? "";
    // Dùng user_id (mã nghiệp vụ ngắn = 提携先ID/事業者ID) để phân biệt, KHÔNG dùng Mongo id dài.
    const displayId = it?.user_id ?? it?.id;
    return counts[n] > 1 ? { ...it, name: `${n} (ID:${displayId})` } : it;
  });
};

export const isAdminSanwa = (userInfo) => userInfo.role == "ROLE_FACILITY" && userInfo.is_sys_admin;
// Super admin = tài khoản Sanwa gốc có mã đăng nhập (事業者ID / user_id) = "00000000".
// Chỉ super admin mới được thêm/sửa/xóa FAQ; các admin Sanwa khác chỉ xem.
export const isSuperAdmin = (userInfo) =>
  isAdminSanwa(userInfo) && String(userInfo?.user_id ?? userInfo?.business_id) === "00000000";
export const isPartner = (userInfo) => userInfo.role == "ROLE_PARTNER" && !userInfo.is_sys_admin;
export const isAdminFacility = (userInfo) => userInfo.role == "ROLE_FACILITY" && !userInfo.is_sys_admin;